import React, { Dispatch, useContext, useState } from 'react';
import { RangeInput } from '@material-ui/pickers';

type ReportAccountContextInterface = {
  activeAccountId: string | undefined;
  setActiveAccountId: Dispatch<string>;
  activeDateRange: RangeInput<Date>;
  setActiveDateRange: Dispatch<RangeInput<Date>>;
};

export const ReportAccountContext = React.createContext<ReportAccountContextInterface>(
  {
    activeAccountId: undefined,
    setActiveAccountId: () => undefined,
    activeDateRange: [null, null],
    setActiveDateRange: () => [null, null],
  }
);

interface ReportAccountContextProviderProps {
  activeAccountIdProp?: string;
}

const ReportAccountContextProvider: React.FC<ReportAccountContextProviderProps> = ({
  activeAccountIdProp,
  children,
}) => {
  const [activeAccountId, setActiveAccountId] = useState<string>(
    activeAccountIdProp || ''
  );
  const [activeDateRange, setActiveDateRange] = useState<RangeInput<Date>>([
    null,
    null,
  ]);

  const values = {
    activeAccountId,
    setActiveAccountId,
    activeDateRange,
    setActiveDateRange,
  };

  return (
    <ReportAccountContext.Provider value={values}>
      {children}
    </ReportAccountContext.Provider>
  );
};

export const useReportAccountContext = (): ReportAccountContextInterface => {
  const reportAccountContext = useContext(ReportAccountContext);

  if (reportAccountContext === null) {
    throw new Error(
      'reportContext must be used within the ReportContextProvider!'
    );
  }

  return {
    ...reportAccountContext,
  };
};

export default ReportAccountContextProvider;
